import React from 'react'
import "./DownTime.css"
import { Chart } from "react-google-charts";

export const data = [
    ["Hour", "DownTime"],
    ["1", 0],
    ["2", 2],
    ["3", 6],
    ["4", 4],
    ["5", 8],
    ["6", 6],
    ["7", 4],
    ["8", 6],
    ["9", 12],
];

const DownTime = () => {

    return (
        <div className='Downtime'>
            <h4 className='exp_Doen'>Total Downtime</h4>
            <div className='row'>
                <div>
                    <Chart
                        className='col-40'
                        chartType="LineChart" // Use "LineChart" for line chart
                        data={data}
                        options={{
                            legend: { position: "none" },
                            chartArea: { left: 50, top: 10, right: 10, bottom: 50 },
                            backgroundColor: '#F8FBFF',
                            hAxis: {
                                 // X-axis label
                                titleTextStyle: { color: '#333' },
                            },
                            vAxis: {
                                 // Y-axis label
                                titleTextStyle: { color: '#333' },
                                format: '#\'h\'', // Format y-axis labels as "2h", "4h", etc.
                            },
                            pointSize: 5, // Adjust the size of the data points
                            pointShape: "circle", // Use "circle" as the shape of the data points
                        }}
                        chartWrapperParams={{ view: { columns: [0, 1] } }}
                    />
                </div>
            </div>
            <div className='bordering_down'>
                
            </div>
            <div className='axis1'><span style={{ color: "#004F95", fontWeight: "700", fontFamily: "Poppins" }}>X-Axis</span> : Weeks</div>
            <div className='axisy1'><span style={{ color: "#004F95", fontWeight: "700", fontFamily: "Poppins" }}>Y-Axis</span> : Weeks</div>
            <div className='text_t'>Total Downtime</div>
            <div className='text_t1'>12Days 3h 20m </div>
        </div>
    )
}

export default DownTime
